import React, { Component } from 'react';
import './Candidate.css'

class Candidate extends Component {

    render() {
        const { id, name, img } = this.props
        return (
            <div className="Candidate">
                <div className="Candidate__name">
                    <h2>{name}</h2>
                </div>
                <div className="Candidate__body">
                    <img className="Candidate__img" src={img} alt="Candidate" />
                </div>
                <div className="Candidate__btn">
                    <div className="btn__vote" onClick={e => {
                        e.preventDefault();
                        this.props.voteClick(id);
                    }} >
                        <h2>VOTAR</h2>
                    </div>
                </div>
            </div>
        );
    }
}

export default Candidate;